"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const attributor_1 = require("./attributor");
function camelize(name) {
    let parts = name.split('-');
    let rest = parts
        .slice(1)
        .map(function (part) {
        return part[0].toUpperCase() + part.slice(1);
    })
        .join('');
    return parts[0] + rest;
}
class StyleAttributor extends attributor_1.default {
    static keys(node) {
        return (node.getAttribute('style') || '').split(';').map(function (value) {
            let arr = value.split(':');
            return arr[0].trim();
        });
    }
    add(node, value) {
        if (!this.canAdd(node, value))
            return false;
        // @ts-ignore
        node.style[camelize(this.keyName)] = value;
        return true;
    }
    remove(node) {
        // @ts-ignore
        node.style[camelize(this.keyName)] = '';
        if (!node.getAttribute('style')) {
            node.removeAttribute('style');
        }
    }
    value(node) {
        // @ts-ignore
        let value = node.style[camelize(this.keyName)];
        return this.canAdd(node, value) ? value : '';
    }
}
exports.default = StyleAttributor;
